<template>
  <div>
    <div class="columns">
      <div class="column">
        <a @click="goBack">Go Back</a>
      </div>
      <div class="column">
        <a @click="dataSourceUI = true" style="float:right;">Select Data Sources</a>
        <p style="float: right; margin-right: 5px;">Logged in as {{userdata.name}} |</p>
      </div>
    </div>
    <div class="columns is-desktop">
      <div class="column" style="padding: 2px;">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title" @click="toggleUI('revenue')">Revenue</p>
          </header>
          <div class="card-content" v-if="ui.revenue">
            <table class="table is-narrow is-fullwidth">
              <thead>
                <tr>
                  <th>Month</th>
                  <th>Gross</th>
                  <th>ADB</th>
                  <th>NEDs</th>
                  <th>Deposits</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(month, idx) in inputs.months" v-bind:key="'month'+idx" :class="month.mg > 0 ? '' : 'ineligible-month'">
                  <td style="width: 82px; padding-top: 10px;">{{month.iso}}</td>
                  <td>
                    <div class="field">
                      <div class="control">
                        <input
                          class="input is-small"
                          type="text"
                          v-model="month.mg"
                          @blur="month.mg = formatMoney(month.mg)"
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="field">
                      <div class="control">
                        <input
                          class="input is-small"
                          type="text"
                          v-model="month.adb"
                          @blur="month.adb = formatMoney(month.adb)"
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="field">
                      <div class="control">
                        <input class="input is-small" type="number" v-model="month.neds" />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="field">
                      <div class="control">
                        <input class="input is-small" type="number" v-model="month.deps" />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <footer class="card-footer">
            <div class="columns">
              <div class="column is-narrow">
                <p style="margin-top: 10px;">Average</p>
              </div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input is-small" type="text" disabled :value="avg('mg')" />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input is-small" type="text" disabled :value="avg('adb')" />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input is-small" type="text" disabled :value="avg('neds')" />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input is-small" type="text" disabled :value="avg('deps')" />
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
      <div class="column" style="padding: 2px;">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title" @click="toggleUI('qualifiers')">Qualifiers</p>
          </header>
          <div class="card-content" v-if="ui.qualifiers">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Commercial Credit</label>
                  <p class="control has-icons-left">
                    <span class="select">
                      <select v-model="inputs.cc">
                        <option>Yes</option>
                        <option>No</option>
                        <option>Yes + Past due</option>
                      </select>
                    </span>
                    <span class="icon is-small is-left">
                      <i class="fas fa-credit-card"></i>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <label class="label">Tax Returns</label>
                  <p class="control has-icons-left">
                    <span class="select">
                      <select v-model="inputs.tr">
                        <option>Yes</option>
                        <option>No</option>
                        <option>Yes + 20% NL</option>
                      </select>
                    </span>
                    <span class="icon is-small is-left">
                      <i class="fas fa-file-invoice-dollar"></i>
                    </span>
                  </p>
                </div>

                <div class="field">
                  <label class="label">Liens/Judgements</label>
                  <p class="control has-icons-left">
                    <span class="select">
                      <select v-model="inputs.liens">
                        <option>0-$75k</option>
                        <option>$75-125k</option>
                        <option>$125-250k</option>
                        <option>$250k+</option>
                      </select>
                    </span>
                    <span class="icon is-small is-left">
                      <i class="fas fa-gavel"></i>
                    </span>
                  </p>
                </div>

                <div class="field">
                  <label class="label">Revolving Available Balance</label>
                  <p class="control has-icons-left">
                    <span class="select">
                      <select v-model="inputs.revolving">
                        <option>50%+</option>
                        <option>25-50%</option>
                        <option>0-25%</option>
                      </select>
                    </span>
                    <span class="icon is-small is-left">
                      <i class="fas fa-balance-scale"></i>
                    </span>
                  </p>
                </div>

                <div class="field">
                  <label class="label">Bankruptcies</label>
                  <p class="control has-icons-left">
                    <span class="select">
                      <select v-model="inputs.bk">
                        <option>0</option>
                        <!-- eslint-disable-next-line -->
                        <option>1,<1 yr</option>
                        <option>1,2-5 yrs</option>
                        <option>1,>5 yrs</option>
                        <option>2+</option>
                      </select>
                    </span>
                    <span class="icon is-small is-left">
                      <i class="fas fa-university"></i>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <label class="label">Trucks (If applicable)</label>
                  <p class="control has-icons-left">
                    <span class="select">
                      <select v-model="inputs.trucks">
                        <option>0</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6+</option>
                      </select>
                    </span>
                    <span class="icon is-small is-left">
                      <i class="fas fa-truck"></i>
                    </span>
                  </p>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">TIB</label>
                  <p class="control has-icons-left">
                    <input
                      class="input"
                      type="text"
                      placeholder="Years"
                      style="padding: 0px 30px;"
                      v-model="inputs.tib"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-hourglass"></i>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <label class="label">Industry</label>
                  <p class="control has-icons-left">
                    <span class="select">
                      <select v-model="inputs.industry">
                        <option>Agriculture</option>
                        <option>Entertainment/Production/Broadcasting</option>
                        <option>Financial services/Tax Prep/Insurance</option>
                        <option>General Contractor/Home Builder</option>
                        <option>Real Estate Management</option>
                        <option>Retail - Mobile Phones</option>
                        <option>Staffing</option>
                        <option>Transportation - Interstate</option>
                        <option value="Core">Other</option>
                      </select>
                    </span>
                    <span class="icon is-small is-left">
                      <i class="fas fa-industry"></i>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <label class="label">Online Presence</label>
                  <div class="control">
                    <label class="radio">
                      <input type="radio" name="online" value="true" v-model="inputs.online" />
                      Yes
                    </label>
                    <label class="radio">
                      <input type="radio" name="online" value="false" v-model="inputs.online" />
                      No
                    </label>
                  </div>
                </div>
                <div class="field">
                  <label class="label">Home Owner</label>
                  <div class="control">
                    <label class="radio">
                      <input
                        type="radio"
                        name="home_owner"
                        value="true"
                        v-model="inputs.home_owner"
                      />
                      Yes
                    </label>
                    <label class="radio">
                      <input
                        type="radio"
                        name="home_owner"
                        value="false"
                        v-model="inputs.home_owner"
                      />
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-desktop">
      <div class="column" style="padding: 2px;">
        <div class="card">
          <header class="card-header">
            <p
              class="card-header-title"
              @click="toggleUI('ficos')"
              style="margin-bottom: 0px;"
            >FICO Scores</p>
            <button
              class="button is-success is-outlined"
              @click="addFico(0)"
              style="margin-right: 5px; margin-top: 5px;"
            >
              <span class="icon is-small">
                <i class="fas fa-plus"></i>
              </span>
            </button>
          </header>
          <div class="card-content" v-if="ui.ficos">
            <table
              class="table is-narrow is-fullwidth is-striped is-hoverable"
              v-if="inputs.ficos.length > 0"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Score</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(fico, idx) in inputs.ficos" v-bind:key="'fico'+idx">
                  <td style="width: 52px; padding-top: 10px;">{{idx+1}}</td>
                  <td>
                    <div class="field">
                      <div class="control">
                        <input class="input is-small" type="number" v-model="fico.score" />
                      </div>
                    </div>
                  </td>
                  <td>
                    <button
                      class="button is-danger is-outlined"
                      style="margin-top: 3px;"
                      @click="removeFico(idx)"
                    >
                      <span class="icon is-small">
                        <i class="fas fa-times"></i>
                      </span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <footer class="card-footer">
            <div class="columns">
              <div class="column is-narrow">
                <p style="margin-top: 10px;">Average FICO:</p>
              </div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input is-small" type="text" disabled :value="avgFicos()" />
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
      <div class="column" style="padding: 2px;">
        <div class="card">
          <header class="card-header">
            <p
              class="card-header-title"
              @click="toggleUI('positions')"
              style="margin-bottom: 0px;"
            >Existing Positions</p>
            <button
              class="button is-success is-outlined"
              @click="addBalance"
              style="margin-right: 5px; margin-top: 5px;"
            >
              <span class="icon is-small">
                <i class="fas fa-plus"></i>
              </span>
            </button>
          </header>
          <div class="card-content" v-if="ui.positions">
            <table
              class="table is-narrow is-fullwidth is-striped is-hoverable"
              v-if="inputs.balances.length > 0"
            >
              <thead>
                <tr>
                  <th>Lender</th>
                  <th>Amount</th>
                  <th>Frequency</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(balance, idx) in inputs.balances" v-bind:key="'balance'+idx">
                  <td>
                    <p class="control">
                      <span class="select">
                        <select v-model="balance.lender">
                          <option
                            v-for="(lender, idx) in lenders"
                            v-bind:key="'lender'+idx"
                          >{{lender.name}}</option>
                        </select>
                      </span>
                    </p>
                  </td>
                  <td>
                    <div class="field">
                      <div class="control">
                        <input class="input" type="text" v-model="balance.amount" />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="field">
                      <p class="control has-icons-left">
                        <span class="select">
                          <select v-model="balance.freq">
                            <option>Daily</option>
                            <option>Weekly</option>
                            <option>Monthly</option>
                          </select>
                        </span>
                        <span class="icon is-small is-left">
                          <i class="fas fa-clock"></i>
                        </span>
                      </p>
                    </div>
                  </td>
                  <td>
                    <button
                      class="button is-danger is-outlined"
                      style="margin-top: 3px;"
                      @click="removeBalance(idx)"
                    >
                      <span class="icon is-small">
                        <i class="fas fa-times"></i>
                      </span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="field">
              <label class="label">Payoff</label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="payoff" value="true" v-model="inputs.payoff" />
                  Yes
                </label>
                <label class="radio">
                  <input type="radio" name="payoff" value="false" v-model="inputs.payoff" />
                  No
                </label>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div class="columns">
              <div class="column is-narrow">
                <p style="margin-top: 10px;">Total Daily Payments:</p>
              </div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input is-small" type="text" disabled :value="'$'+totalBalances()" />
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
    <div class="buttons is-centered">
      <button class="button is-success" @click="calculate">
        <span class="icon is-small">
          <i class="fas fa-check"></i>
        </span>
        <span>Calculate</span>
      </button>
    </div>
    <div class="modal" style="display: block" v-if="dataSourceUI">
      <div class="modal-background"></div>
      <div class="modal-card" style="margin-top: 100px; width: 90%;">
        <header class="modal-card-head">
          <p class="modal-card-title" style="margin-bottom: 0px;">Populate Data</p>
          <button class="delete" aria-label="close" @click="dataSourceUI = false"></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          <div class="columns">
            <div class="column">
              <div class="card">
                <header class="card-header">
                  <p class="card-header-title">Revenue Sources</p>
                </header>
                <div class="card-content" style="padding: 1rem;">
                  <article
                    class="notification is-primary is-small bank-source"
                    v-for="(account, idx) in computedRevSources"
                    v-bind:key="'account'+idx"
                    @click="selectAccount(account)"
                    :class="account.selected ? 'source-selected' : ''"
                  >
                    <div v-if="account.url">
                      <p
                        class="title"
                        style="font-size: 1rem; margin-bottom: 15px;"
                      >Bank Analysis File</p>
                      <p
                        class="subtitle"
                        style="font-size: 0.9rem; margin-top: 0px; margin-bottom: 5px;"
                      >Uploaded {{formatUnixDate(account.sent)}}</p>
                      <div class="columns">
                        <div class="column is-narrow"></div>
                        <div class="column">
                          <span
                            class="icon is-large"
                            style="position: absolute; right: 20px; top: 10px; transition: all 0.3s;"
                            :class="account.selected ? 'shown' : 'hidden'"
                          >
                            <i class="fas fa-3x fa-check-square"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <p class="title" style="font-size: 1rem; margin-bottom: 5px;">{{account.name}}</p>
                      <p
                        class="subtitle"
                        style="font-size: 0.9rem; margin-top: 0px; margin-bottom: 5px;"
                      >{{account.accnum}} - ${{account.balance}}</p>
                      <div class="columns">
                        <div class="column is-narrow">
                          <p
                            class="subtitle"
                            style="font-size: 0.8rem; margin-top: 5px; color: #ffffffbd;"
                          >{{account.institution}} - {{formatUnixDate(account.timestamp)}}</p>
                        </div>
                        <div class="column">
                          <span
                            class="icon is-large"
                            style="position: absolute; right: 20px; top: 19px; transition: all 0.3s;"
                            :class="account.selected ? 'shown' : 'hidden'"
                          >
                            <i class="fas fa-3x fa-check-square"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <header class="card-header">
                  <p class="card-header-title">FICO Sources</p>
                </header>
                <div class="card-content" style="padding: 1rem;">
                  <article
                    class="notification is-primary is-small fico-source"
                    v-for="(src, idx) in ficoSources"
                    v-bind:key="src.src"
                    @click="populateFicoData(src, idx)"
                    :class="fico_index == idx ? 'source-selected' : ''"
                  >
                    <p class="title" style="font-size: 1rem; margin-bottom: 5px;">{{src.src}}</p>
                    <p
                      class="subtitle"
                      style="font-size: 0.9rem; margin-top: 0px;     margin-bottom: 5px;"
                    >{{src.scores.length}} {{src.scores.length > 1 ? 'Scores' : 'Score'}}</p>
                    <span
                      class="icon is-large"
                      style="position: absolute; right: 20px; top: 10px; transition: all 0.3s;"
                      :class="fico_index == idx ? 'shown' : 'hidden'"
                    >
                      <i class="fas fa-3x fa-check-square"></i>
                    </span>
                  </article>
                </div>
              </div>
            </div>
          </div>
          <table class="table is-fullwidth is-narrow is-striped">
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
                <th>Source</th>
              </tr>
            </thead>
            <tbody name="table" is="transition-group">
              <tr v-for="(field, idx) in crmFields" v-bind:key="'crmfield'+idx">
                <td>{{field.name}}</td>
                <td>{{field.value}}</td>
                <td>{{field.source}}</td>
              </tr>
            </tbody>
          </table>
        </section>
        <footer class="modal-card-foot" style="padding: 30px;">
          <button
            class="button is-link is-right"
            style="position: absolute; right: 10px;"
            @click="finishedData"
            :class="dataSourceLoading ? 'is-loading' : ''"
          >Continue</button>
        </footer>
      </div>
    </div>
    <div v-if="results.fp">
      <div class="columns">
        <div class="column is-one-third">
          <h3>{{results.fp.status}}</h3>
          <hr />
          <div class="box" style="text-align: center; font-variant-caps: all-petite-caps;">
            <p class="title">{{results.score.grade}}</p>
            <p
              class="subtitle"
              style="font-variant-caps: all-small-caps; font-size: 0.9rem;text-align: center; color: grey;"
            >{{results.score.score}} Points</p>
          </div>

          <h5 style="font-variant-caps: all-small-caps; color: grey;">Score Breakdown</h5>

          <article
            class="notification is-link is-small"
            style="margin-bottom: 2px; padding: 3px 5px; background-color: white; box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.3);"
            v-for="(factor, idx) in results.score.factors"
            v-bind:key="'factor'+idx"
          >
            <p
              class="title"
              style="font-size: 1rem; margin-bottom: 5px; font-variant-caps: all-small-caps; color: black;"
            >{{factor.name}}</p>

            <div class="columns">
              <div class="column is-narrow">
                <p
                  class="subtitle"
                  style="font-size: 0.8rem; color: grey; font-variant-caps: all-small-caps;"
                >{{factor.reasons}}</p>
              </div>
              <div class="column" style="text-align: right;">
                <p
                  class="subtitle"
                  style="font-size: 0.8rem; color: grey; font-variant-caps: all-small-caps;"
                >
                  <strong>{{factor.score}}</strong>
                  /{{factor.maxScore}} POINTS
                </p>
              </div>
            </div>
          </article>
        </div>
        <div class="column" style="padding-top: 90px;" v-if="results.fp.status == 'Declined'">
          <h4>Decline Reasons:</h4>
          <ul>
            <li v-for="(decline, idx) in results.fp.reasons" v-bind:key="'decline'+idx">{{decline}}</li>
          </ul>
        </div>
        <div class="column" v-else>
          <div class="tabs is-centered is-boxed is-medium">
            <ul>
              <li :class="editor.view == 'fp' ? 'is-active' : ''">
                <a @click="editor.view = 'fp'">
                  <span class="icon is-small">
                    <i class="fas fa-trophy" aria-hidden="true"></i>
                  </span>
                  <span>First Position</span>
                </a>
              </li>
              <li :class="editor.view == 'sp' ? 'is-active' : ''">
                <a @click="editor.view = 'sp'">
                  <span class="icon is-small">
                    <i class="fas fa-coins" aria-hidden="true"></i>
                  </span>
                  <span>Stack</span>
                </a>
              </li>
            </ul>
          </div>
          <transition name="fade" mode="out-in" v-if="editor.view == 'fp'">
            <div v-if="editor.fp.customize == false" key="primary">
              <div class="columns">
                <div class="column">
                  <div
                    class="box"
                    style="text-align: center; font-variant-caps: all-petite-caps; background: #2196f3;"
                  >
                    <p
                      class="title"
                      style="color: white;"
                    >${{numberWithCommas(results.fp.payments_in_adb >= 15 ? results.fp.loan_approval : results.fp.adb_15_approval, true)}}</p>
                    <p
                      class="subtitle"
                      style="font-variant-caps: all-small-caps; font-size: 0.9rem;text-align: center; color: #f0f0f0;"
                    >Payments in ADB: {{numberWithCommas(results.fp.payments_in_adb, true)}} {{results.fp.payments_in_adb >= 15 ? '' : '(ADJUSTED to 15)'}}</p>
                    <p
                      class="subtitle"
                      style="font-variant-caps: all-small-caps; font-size: 0.9rem;text-align: center; color: #f0f0f0;"
                    >{{results.fp.percent_amg_approved}}% ADB Approved</p>
                  </div>
                </div>
              </div>

              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>Term</th>
                    <th>Amount</th>
                    <th>Daily Payment</th>
                    <th>Rate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in results.table" v-bind:key="'approvalrow'+idx">
                    <td>{{row.term}}</td>
                    <td>${{numberWithCommas(row.amount, true)}}</td>
                    <td>${{numberWithCommas(row.daily_payment, true)}}</td>
                    <td>{{row.rate}}</td>
                  </tr>
                </tbody>
              </table>
              <hr />
              <div class="buttons is-centered">
                <button class="button is-link is-outlined" @click="editor.fp.customize = true">
                  <span class="icon is-small">
                    <i class="fas fa-magic"></i>
                  </span>
                  <span>Customize Offer</span>
                </button>
              </div>
            </div>

            <div v-if="editor.fp.customize == true" key="customize">
              <div class="columns" style="text-align: center;">
                <div class="column">
                  <p style="margin-bottom: 5px;">Loan Approval</p>
                  <div class="control has-icons-right" v-if="!editor.fp.edit">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center; cursor: pointer;"
                      :class="parseFloat(editor.fp.loan_approval) > parseFloat(results.fp.loan_approval) ? '' : 'ok-field'"
                      :value="'$'+numberWithCommas(editor.fp.loan_approval, true)"
                      disabled
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseFloat(editor.fp.loan_approval) <= parseFloat(results.fp.loan_approval)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <div class="control has-icons-right" v-if="editor.fp.edit">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center;"
                      :class="parseFloat(editor.fp.loan_approval) > parseFloat(results.fp.loan_approval) ? '' : 'ok-field'"
                      v-model="editor.fp.loan_approval"
                      @change="customizeApproval(editor.fp)"
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseFloat(editor.fp.loan_approval) <= parseFloat(results.fp.loan_approval)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <p></p>
                </div>
                <div class="column">
                  <p style="margin-bottom: 5px;">Daily Payment</p>
                  <div class="control has-icons-right">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center;"
                      :class="parseInt(editor.fp.daily_payment) > parseInt(results.fp.daily_payment) ? '' : 'ok-field'"
                      :value="'$'+numberWithCommas(editor.fp.daily_payment, true)"
                      disabled
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseInt(editor.fp.daily_payment) <= parseInt(results.fp.daily_payment)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <p></p>
                </div>
                <div class="column">
                  <p style="margin-bottom: 5px;">% AMG Approved</p>
                  <div class="control has-icons-right">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center;"
                      :class="parseFloat(editor.fp.percent_amg_approved) > parseFloat(results.fp.percent_amg_approved) ? '' : 'ok-field'"
                      :value="editor.fp.percent_amg_approved+'%'"
                      disabled
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseFloat(editor.fp.percent_amg_approved) <= parseFloat(results.fp.percent_amg_approved)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <p></p>
                </div>
                <div class="column is-narrow">
                  <div class="buttons is-centered" style="margin-top: 33px;">
                    <button
                      class="button is-link is-outlined"
                      @click="editApproval(editor.fp)"
                      v-if="!editor.fp.edit"
                    >
                      <span class="icon is-small">
                        <i class="fas fa-pen"></i>
                      </span>
                      <span>Modify</span>
                    </button>
                    <button class="button is-success" @click="commitApproval(editor.fp)" v-else>
                      <span class="icon is-small">
                        <i class="fas fa-check"></i>
                      </span>
                      <span>Commit</span>
                    </button>
                  </div>
                </div>
              </div>
              <vue-slider
                v-model="editor.fp.loan_approval"
                :min="constraints.MIN_APPROVAL"
                :max="maxApproval(editor.fp)"
                :enable-cross="false"
                @dragging="customizeApproval(editor.fp)"
                v-if="!editor.fp.edit"
              ></vue-slider>

              <div class="columns is-centered" style="text-align: center;">
                <div class="column is-one-third">
                  <p style="margin-bottom: 5px;">Max Term</p>
                  <div class="control has-icons-right">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center;"
                      :class="parseFloat(editor.fp.term_months) > parseFloat(results.fp.term_months) ? '' : 'ok-field'"
                      :value="editor.fp.term_months+' months'"
                      disabled
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseFloat(editor.fp.term_months) <= parseFloat(results.fp.term_months)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <p></p>
                </div>
              </div>
              <vue-slider
                v-model="editor.fp.term_months"
                :min="constraints.MIN_MONTHS"
                :max="constraints.MAX_MONTHS"
                :enable-cross="false"
                @dragging="customizeApproval(editor.fp)"
              ></vue-slider>
              <p
                class="subtitle"
                style="font-variant-caps: all-small-caps; font-size: 0.9rem;text-align: center;"
              >Payments in ADB: {{numberWithCommas(editor.fp.payments_in_adb, true)}} {{editor.fp.payments_in_adb >= 15 ? '' : '(ADJUSTED to 15)'}}</p>
              <table class="table is-fullwidth is-narrow is-striped">
                <thead>
                  <tr>
                    <th>Term</th>
                    <th>Amount</th>
                    <th>Daily Payment</th>
                    <th>Rate</th>
                  </tr>
                </thead>
                <tbody name="table" is="transition-group">
                  <tr v-for="(row, idx) in editor.table" v-bind:key="'editorrow'+idx">
                    <td>{{row.term}}</td>
                    <td>${{numberWithCommas(row.amount, true)}}</td>
                    <td>${{numberWithCommas(row.daily_payment, true)}}</td>
                    <td>{{row.rate}}</td>
                  </tr>
                </tbody>
              </table>
              <!-- <h4 style="margin-top: 20px;">Stips</h4>
              <hr />-->

              <div class="buttons is-centered">
                <button class="button is-danger is-outlined" @click="cancelEdit(editor.fp)">
                  <span class="icon is-small">
                    <i class="fas fa-ban"></i>
                  </span>
                  <span>Cancel</span>
                </button>
                <button class="button is-link is-outlined" @click="revertEdit('fp')">
                  <span class="icon is-small">
                    <i class="fas fa-undo"></i>
                  </span>
                  <span>Revert</span>
                </button>
                <button class="button is-success is-outlined" @click="editor.show = false">
                  <span class="icon is-small">
                    <i class="fas fa-check"></i>
                  </span>
                  <span>Submit to Snack</span>
                </button>
              </div>
            </div>
          </transition>
          <transition name="fade" mode="out-in" v-if="editor.view == 'sp'">
            <div v-if="editor.sp.customize == false" key="stackprimary">
              <div class="columns">
                <div class="column">
                  <div
                    class="box"
                    style="text-align: center; font-variant-caps: all-petite-caps; background: #dd1111;"
                  >
                    <p
                      class="title"
                      style="color: white;"
                    >${{numberWithCommas(results.sp.payments_in_adb >= 15 ? results.sp.loan_approval : results.sp.adb_15_approval, true)}}</p>
                    <p
                      class="subtitle"
                      style="font-variant-caps: all-small-caps; font-size: 0.9rem;text-align: center; color: #f0f0f0;"
                    >Payments in ADB: {{numberWithCommas(results.sp.payments_in_adb, true)}} {{results.sp.payments_in_adb >= 15 ? '' : '(ADJUSTED to 15)'}}</p>
                                      <p
                      class="subtitle"
                      style="font-variant-caps: all-small-caps; font-size: 0.9rem;text-align: center; color: #f0f0f0;"
                    >{{results.sp.percent_amg_approved}}% ADB Approved</p>
                  </div>
                </div>
              </div>

              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>Term</th>
                    <th>Amount</th>
                    <th>Daily Payment</th>
                    <th>Rate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in results.table_sp" v-bind:key="'approvalsprow'+idx">
                    <td>{{row.term}}</td>
                    <td>${{numberWithCommas(row.amount, true)}}</td>
                    <td>${{numberWithCommas(row.daily_payment, true)}}</td>
                    <td>{{row.rate}}</td>
                  </tr>
                </tbody>
              </table>
              <hr />
              <div class="buttons is-centered">
                <button class="button is-link is-outlined" @click="editor.sp.customize = true">
                  <span class="icon is-small">
                    <i class="fas fa-magic"></i>
                  </span>
                  <span>Customize Offer</span>
                </button>
              </div>
            </div>

            <div v-if="editor.sp.customize == true" key="stackcustomize">
              <div class="columns" style="text-align: center;">
                <div class="column">
                  <p style="margin-bottom: 5px;">Loan Approval</p>
                  <div class="control has-icons-right" v-if="!editor.sp.edit">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center; cursor: pointer;"
                      :class="parseFloat(editor.sp.loan_approval) > parseFloat(results.sp.loan_approval) ? '' : 'ok-field'"
                      :value="'$'+numberWithCommas(editor.sp.loan_approval, true)"
                      disabled
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseFloat(editor.sp.loan_approval) <= parseFloat(results.sp.loan_approval)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <div class="control has-icons-right" v-if="editor.sp.edit">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center;"
                      :class="parseFloat(editor.sp.loan_approval) > parseFloat(results.sp.loan_approval) ? '' : 'ok-field'"
                      v-model="editor.sp.loan_approval"
                      @change="customizeApproval(editor.sp)"
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseFloat(editor.sp.loan_approval) <= parseFloat(results.sp.loan_approval)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <p></p>
                </div>
                <div class="column">
                  <p style="margin-bottom: 5px;">Daily Payment</p>
                  <div class="control has-icons-right">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center;"
                      :class="parseInt(editor.sp.daily_payment) > parseInt(results.sp.daily_payment) ? '' : 'ok-field'"
                      :value="'$'+numberWithCommas(editor.sp.daily_payment, true)"
                      disabled
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseInt(editor.sp.daily_payment) <= parseInt(results.sp.daily_payment)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <p></p>
                </div>
                <div class="column">
                  <p style="margin-bottom: 5px;">% AMG Approved</p>
                  <div class="control has-icons-right">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center;"
                      :class="parseFloat(editor.sp.percent_amg_approved) > parseFloat(results.sp.percent_amg_approved) ? '' : 'ok-field'"
                      :value="editor.sp.percent_amg_approved+'%'"
                      disabled
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseFloat(editor.sp.percent_amg_approved) <= parseFloat(results.sp.percent_amg_approved)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <p></p>
                </div>
                <div class="column is-narrow">
                  <div class="buttons is-centered" style="margin-top: 33px;">
                    <button
                      class="button is-link is-outlined"
                      @click="editApproval(editor.sp)"
                      v-if="!editor.fp.edit"
                    >
                      <span class="icon is-small">
                        <i class="fas fa-pen"></i>
                      </span>
                      <span>Modify</span>
                    </button>
                    <button class="button is-success" @click="commitApproval(editor.sp)" v-else>
                      <span class="icon is-small">
                        <i class="fas fa-check"></i>
                      </span>
                      <span>Commit</span>
                    </button>
                  </div>
                </div>
              </div>
              <vue-slider
                v-model="editor.sp.loan_approval"
                :min="constraints.MIN_APPROVAL"
                :max="maxApproval(editor.sp)"
                :enable-cross="false"
                @dragging="customizeApproval(editor.sp)"
                v-if="!editor.sp.edit"
              ></vue-slider>

              <div class="columns is-centered" style="text-align: center;">
                <div class="column is-one-third">
                  <p style="margin-bottom: 5px;">Max Term</p>
                  <div class="control has-icons-right">
                    <input
                      class="input is-medium"
                      type="text"
                      style="text-align: center;"
                      :class="parseFloat(editor.sp.term_months) > parseFloat(results.sp.term_months) ? '' : 'ok-field'"
                      :value="editor.sp.term_months+' months'"
                      disabled
                    />
                    <span
                      class="icon is-medium is-right"
                      v-if="parseFloat(editor.sp.term_months) <= parseFloat(results.sp.term_months)"
                    >
                      <i class="fas fa-check" style="color: #81d281;"></i>
                    </span>
                  </div>
                  <p></p>
                </div>
              </div>
              <vue-slider
                v-model="editor.sp.term_months"
                :min="constraints.MIN_MONTHS"
                :max="constraints.MAX_MONTHS"
                :enable-cross="false"
                @dragging="customizeApproval(editor.sp)"
              ></vue-slider>
              <p
                class="subtitle"
                style="font-variant-caps: all-small-caps; font-size: 0.9rem;text-align: center;"
              >Payments in ADB: {{numberWithCommas(editor.sp.payments_in_adb, true)}} {{editor.sp.payments_in_adb >= 15 ? '' : '(ADJUSTED to 15)'}}</p>
              <table class="table is-fullwidth is-narrow is-striped">
                <thead>
                  <tr>
                    <th>Term</th>
                    <th>Amount</th>
                    <th>Daily Payment</th>
                    <th>Rate</th>
                  </tr>
                </thead>
                <tbody name="table" is="transition-group">
                  <tr v-for="(row, idx) in editor.table" v-bind:key="'editorrow'+idx">
                    <td>{{row.term}}</td>
                    <td>${{numberWithCommas(row.amount, true)}}</td>
                    <td>${{numberWithCommas(row.daily_payment, true)}}</td>
                    <td>{{row.rate}}</td>
                  </tr>
                </tbody>
              </table>
              <!-- <h4 style="margin-top: 20px;">Stips</h4>
              <hr />-->

              <div class="buttons is-centered">
                <button class="button is-danger is-outlined" @click="cancelEdit(editor.sp)">
                  <span class="icon is-small">
                    <i class="fas fa-ban"></i>
                  </span>
                  <span>Cancel</span>
                </button>
                <button class="button is-link is-outlined" @click="revertEdit('sp')">
                  <span class="icon is-small">
                    <i class="fas fa-undo"></i>
                  </span>
                  <span>Revert</span>
                </button>
                <button class="button is-success is-outlined" @click="editor.show = false">
                  <span class="icon is-small">
                    <i class="fas fa-check"></i>
                  </span>
                  <span>Submit to Snack</span>
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Input from "@/components/shared/Input";
import moment from "moment";
// import "vue-range-component/dist/vue-range-slider.css";
// import VueRangeSlider from "vue-range-component";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  name: "decisionwizard",
  components: {
    VueSlider
  },
  props: {
    appnum: String,
    accounts: Array,
    reports: Array,
    token: String,
    userdata: Object
  },
  data() {
    return {
      pass: Input.model(),
      lenders: [
        { name: "American Express", payoff: false },
        { name: "Ascentium", payoff: true },
        { name: "BFS", payoff: true },
        { name: "Bluevine", payoff: false },
        { name: "CAN Capital", payoff: true },
        { name: "CDG", payoff: true },
        { name: "CFG", payoff: true },
        { name: "Channel Partners", payoff: true },
        { name: "Credibly", payoff: true },
        { name: "Everest", payoff: true },
        { name: "Expansion Capital Group", payoff: true },
        { name: "FORA", payoff: true },
        { name: "Forward Financing", payoff: true },
        { name: "Fundbox", payoff: false },
        { name: "Funding Circle", payoff: false },
        { name: "Fundworks", payoff: false },
        { name: "Gibraltar Capital", payoff: true },
        { name: "Intuit", payoff: false },
        { name: "IOU", payoff: true },
        { name: "Kabbage", payoff: false },
        { name: "Kings Cash Group", payoff: true },
        { name: "Knight Capital", payoff: true },
        { name: "Lending Club", payoff: false },
        { name: "Lendini/Funding Metrics", payoff: true },
        { name: "Libertas", payoff: true },
        { name: "Loan Me", payoff: false },
        { name: "Marlin", payoff: true },
        { name: "Mulligan", payoff: true },
        { name: "National Funding", payoff: true },
        { name: "On Deck", payoff: true },
        { name: "Paypal/Swift", payoff: false },
        { name: "Pearl", payoff: true },
        { name: "PIRS Capital", payoff: true },
        { name: "Quarterspot", payoff: true },
        { name: "Quickbridge", payoff: true },
        { name: "Rapid", payoff: true },
        { name: "Reliant Funding", payoff: true },
        { name: "Shopify", payoff: false },
        { name: "Snap Advances", payoff: true },
        { name: "Square", payoff: false },
        { name: "Strategic/Kapitus ", payoff: true },
        { name: "Susquehanna", payoff: true },
        { name: "Zoomli", payoff: true }
      ],
      inputs: {
        months: [
          { mg: 0, adb: 0, neds: 0, deps: 0 },
          { mg: 0, adb: 0, neds: 0, deps: 0 },
          { mg: 0, adb: 0, neds: 0, deps: 0 },
          { mg: 0, adb: 0, neds: 0, deps: 0 },
          { mg: 0, adb: 0, neds: 0, deps: 0 },
          { mg: 0, adb: 0, neds: 0, deps: 0 }
        ],
        ficos: [{ score: 0 }],
        tib: 1,
        industry: "Core",
        tr: "Yes",
        cc: "Yes",
        online: true,
        home_owner: true,
        bk: "0",
        liens: "0-$75k",
        revolving: "50%+",
        balances: [],
        payoff: false,
        trucks: 0
      },
      revSources: [],
      ficoSources: [],
      crmFields: [],
      fico_index: -1,
      dataSourceUI: true,
      dataSourceLoading: false,
      ui: {
        revenue: true,
        qualifiers: true,
        ficos: true,
        positions: true
      },
      results: {
        score: null,
        fp: null,
        sp: null,
        pricing: null,
        table: [],
        table_sp: []
      },
      editor: {
        fp: null,
        sp: null,
        show: false,
        table: [],
        table_sp: [],
        view: "fp"
      },
      constraints: {
        MIN_MONTHS: 3,
        MAX_MONTHS: 12,
        MIN_APPROVAL: 5000,
        MAX_APPROVAL: 100000
      }
    };
  },
  computed: {
    computedRevSources: function() {
      let arr = [];

      this.revSources.forEach(source => {
        //filter out anything that isn't BA for now
        if (source.url) {
          arr.push(source);
        }
      });

      return arr;
    }
  },
  methods: {
    toggleUI(elem) {
      this.ui[elem] = !this.ui[elem];
    },
    editApproval(pos) {
      console.log("editApproval");
      if (
        pos.loan_approval < this.constraints.MIN_APPROVAL ||
        pos.loan_approval > this.maxApproval(pos)
      ) {
        alert(
          "The entered amount falls outside of the model constraints. Please try a value between $" +
            this.constraints.MIN_APPROVAL +
            " and $" +
            this.maxApproval(pos)
        );
        return;
      }
      pos.edit = !pos.edit;
      console.log(pos);

      this.customizeApproval(pos);
    },
    commitApproval(position) {
      console.log("committing approval");
      this.editApproval(position);
    },
    calculate() {
      //create data obj to send to api
      let self = this;
      let api_liens = 0;
      switch (this.inputs.liens) {
        case "$75-125k":
          api_liens = 100000;
          break;
        case "$125-250k":
          api_liens = 175000;
          break;
        case "$250k+":
          api_liens = 300000;
          break;
      }
      let api_revolving = 90;
      switch (this.inputs.revolving) {
        case "25-50%":
          api_revolving = 30;
          break;
        case "0-25%":
          api_revolving = 10;
          break;
      }
      let api_ficos = [];
      this.inputs.ficos.forEach(fico => {
        api_ficos.push(fico.score);
      });
      let data_obj = {
        months: this.inputs.months,
        tib: this.inputs.tib,
        ficos: api_ficos,
        industry: this.inputs.industry == "Core" ? "Core" : "Non-Core",
        tr: this.inputs.tr,
        cc: this.inputs.cc,
        online: this.inputs.online,
        home_owner: this.inputs.home_owner,
        liens: api_liens,
        revolving: api_revolving,
        bk: this.inputs.bk,
        payoff: this.inputs.payoff.toString(),
        other_daily_payment: parseFloat(this.totalBalances())
      };
      console.log("sending", data_obj);
      $.ajax({
        type: "POST",
        url: "/api/services/model",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify(data_obj)
      })
        .done(function(response) {
          console.log(response);
          if (response.fp) {
            self.results.fp = response.fp;
            self.results.score = response.score;
            self.results.pricing = response.pricing;
            response.fp.edit = false;
            response.fp.customize = false;
            // self.editor.fp = response.fp;
            self.editor.fp = Object.assign({}, response.fp);
            // self.editor.fp.edit = false;
            self.editor.fp.loan_approval = parseFloat(
              self.editor.fp.loan_approval
            ).toFixed(2);
            self.results.fp.loan_approval = parseFloat(
              self.results.fp.loan_approval
            ).toFixed(2);
            self.editor.table = self.generateTable(self.editor.fp);
            // self.editor.fp.term_months = [3, self.editor.fp.term_months]
            self.results.table = self.generateTable(response.fp);
          }
          if (response.sp) {
            self.results.sp = response.sp;
            response.sp.edit = false;
            response.sp.customize = false;
            // self.editor.fp = response.fp;
            self.editor.sp = Object.assign({}, response.sp);
            // self.editor.fp.edit = false;
            self.editor.sp.loan_approval = parseFloat(
              self.editor.sp.loan_approval
            ).toFixed(2);
            self.results.sp.loan_approval = parseFloat(
              self.results.sp.loan_approval
            ).toFixed(2);
            self.editor.table_sp = self.generateTable(self.editor.sp, 'C');
            // self.editor.fp.term_months = [3, self.editor.fp.term_months]
            self.results.table_sp = self.generateTable(response.sp, 'C');
          }
        })
        .fail(function(err) {
          console.log(err.responseText);
          alert(err.responseText);
        });
    },
    goBack() {
      this.$emit("goBack", this.$data);
    },
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    cancelEdit(pos) {
      pos.customize = false;
      // this.calculate()
    },
    revertEdit(pos) {
      console.log('revert edit')
      this.editor[pos] = Object.assign({}, this.results[pos]);
      this.editor[pos].loan_approval = parseFloat(
        this.editor[pos].loan_approval
      ).toFixed(2);
      this.editor[pos].table = this.generateTable(this.editor[pos]);
      this.editor[pos].customize = true
    },
    maxApproval(approval) {
      let max = this.constraints.MAX_APPROVAL;
      const self = this;
      //new daily payment
      let adb_15_adjustment = self.avg("adb") / 15;
      // new daily payment
      if (adb_15_adjustment) {
        const term_months = approval.term_months;
        let calculated_factor =
          self.results.pricing[self.results.score.grade]["rates"][term_months];
        let adb_15_approval =
          (adb_15_adjustment * 21 * term_months) / calculated_factor;

        if (adb_15_approval < this.constraints.MAX_APPROVAL) {
          max = adb_15_approval;
        }
      }
      max = Math.ceil(max);
      if (approval.loan_approval > max) {
        approval.loan_approval = max;
      }
      console.log("max approval", max);
      return max;
    },
    customizeApproval(approval) {
      console.log("customizeApproval");
      var self = this;
      let other_daily_payment = parseFloat(self.totalBalances());
      const term_months = approval.term_months;
      let calculated_factor =
        self.results.pricing[self.results.score.grade]["rates"][term_months];
      approval.percent_amg_approved =
        (((approval.loan_approval / term_months) * calculated_factor) /
          self.avg("mg")) *
        100;
      // recalc daily payment and max months
      approval.loan_approval = parseFloat(approval.loan_approval).toFixed(2);
      //figure out daily payment from new loan approval
      approval.daily_payment =
        ((approval.percent_amg_approved / 100) * self.avg("mg")) / 21;
      if (self.inputs.payoff == false) {
        console.log("adjusting for payoff");
        approval.daily_payment =
          ((approval.percent_amg_approved / 100) * self.avg("mg")) / 21;
      }
      // we need to change the loan approval if max term goes up
      approval.percent_amg_approved = parseFloat(
        approval.percent_amg_approved
      ).toFixed(2);
      approval.loan_approval = parseFloat(
        (approval.daily_payment * term_months * 21) / calculated_factor
      ).toFixed(2);

      approval.payments_in_adb = self.avg("adb") / approval.daily_payment;

      if (approval.payments_in_adb < 15) {
        console.log(
          "payments in adb less than 15 so we adjust the daily payment"
        );
        approval.daily_payment = approval.adb_15_adjustment;
      }
      // console.log('new loan approval', approval.loan_approval)
      // regenerate the table with new values
      self.editor.table = self.generateTable(approval);
    },
    generateTable(approval, grade = null) {
      // console.log("generating table");
      let self = this;
      let months = approval.term_months;
      let arr = [];
      // create table for months
      for (var i = months; i >= self.constraints.MIN_MONTHS; i--) {
        console.log('should get pricing for grade '+grade)
        let rate = self.results.pricing[self.results.score.grade]["rates"][i];
        if (grade != null){
          rate = self.results.pricing[grade]["rates"][i];
        }
        
        let month = {
          amount: (approval.daily_payment * 21 * i) / rate,
          rate: rate,
          daily_payment: approval.daily_payment,
          term: i
        };
        // only push to the array if the approval is valid
        if (month.amount >= self.constraints.MIN_APPROVAL) {
          arr.push(month);
        }
      }
      return arr;
    },
    avg(field) {
      let total = 0;
      let num = 0
      this.inputs.months.forEach(month => {
        if (month.mg > 0){
          num++
        }
        total += parseFloat(month[field]);
      });
      return parseFloat(total / num).toFixed(2);
    },
    avgFicos() {
      let total = 0;
      this.inputs.ficos.forEach(fico => {
        total += parseInt(fico.score);
      });
      return parseInt(total / this.inputs.ficos.length);
    },
    formatMoney(x) {
      if (x != null) {
        if (String(x).search(/^\$?\d+(,\d{3})*(\.\d*)?$/) >= 0) {
          //already valid
          return parseFloat(x).toFixed(2);
        } else {
          return parseFloat(x)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        }
      }
    },
    numberWithCommas(val, money = false) {
      if (money) val = parseFloat(val).toFixed(2);
      var returnval = null;
      if (val != null)
        returnval = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (returnval == "NaN") returnval = "0.00";

      return returnval;
    },
    formatUnixDate(ts) {
      // console.log("formatting", ts);
      return moment.unix(ts).format("l");
    },
    authenticate() {
      if (this.loading) {
        return;
      }
      var self = this;
    },
    addFico(amount = 0) {
      this.inputs.ficos.push({ score: amount });
    },
    removeFico(index) {
      this.inputs.ficos.splice(index, 1);
    },
    addBalance() {
      this.inputs.balances.push({ lender: "", amount: 0, freq: "Daily" });
    },
    removeBalance(index) {
      this.inputs.balances.splice(index, 1);
    },
    totalBalances() {
      var total = 0;
      this.inputs.balances.forEach(function(bal) {
        if (!(bal.amount > 0)) {
          return;
        }
        if (bal.freq == "Monthly") {
          total += parseFloat(bal.amount / 21);
        } else if (bal.freq == "Weekly") {
          total += parseFloat(bal.amount * 0.20619048);
        } else {
          // it's a daily
          total += parseFloat(bal.amount);
        }
      });
      return parseFloat(total).toFixed(2);
    },
    populateFicoData(source, idx) {
      this.inputs.ficos = [];
      var self = this;
      source.scores.forEach(function(score) {
        self.addFico(score);
      });
      this.fico_index = idx;
    },
    async finishedData() {
      //get fin data
      var self = this;
      self.dataSourceLoading = true;
      var promises = [];
      this.revSources.forEach(source => {
        if (source.selected) promises.push(self.getFinData(source));
      });
      this.crmFields.forEach(field => {
        self.inputs[field.field] = field.value;
      });
      let results = await Promise.all(promises);
      let highestGross = Number.NEGATIVE_INFINITY;
      // reset all the months since we're populating from a data source
      self.inputs.months.forEach(month => {
        month.mg = 0;
        month.adb = 0;
        month.neds = 0;
        month.deps = 0;
      });
      // account scope
      results.forEach(accres => {
        console.log("....", accres.gross, accres.months);
        // so this is an account, we need to add all the revenue but replace the ADB, NEDS, and DEPs if the gross is higher than highestGross
        if (accres.gross >= highestGross) {
          accres.months.forEach(accmo => {
            self.inputs.months.forEach(month => {
              if (accmo.month == month.iso) {
                month.adb = accmo.adb;
                month.neds = accmo.neds;
                month.deps = accmo.deps;
              }
            });
          });
          highestGross = accres.gross;
        }

        // this will happen for all months - adding the gross for the month
        accres.months.forEach(accmo => {
          self.inputs.months.forEach(month => {
            if (accmo.month == month.iso) {
              month.mg += accmo.mg;
            }
          });
        });
      });
      // final formatting
      self.inputs.months.forEach(month => {
        month.adb = parseFloat(month.adb).toFixed(2);
        month.neds = parseInt(month.neds);
        month.deps = parseInt(month.deps);
        month.mg = parseFloat(month.mg).toFixed(2);
      });
      self.dataSourceLoading = false;
      self.dataSourceUI = false;
      console.log(results);
    },
    selectAccount(acc) {
      console.log("selecting account");
      if (acc.url) {
        // deselect all others
        this.revSources.forEach(account => {
          account.selected = false;
        });
      } else {
        this.revSources.forEach(account => {
          if (account.url) account.selected = false;
        });
      }
      acc.selected = !acc.selected;
    },
    async getFinData(account) {
      console.log("get fin data");
      return new Promise((res, rej) => {
        console.log(account);
        var self = this;
        if (account.url) {
          console.log("NEED TO GET DATA FROM BA FILE");

          $.ajax({
            type: "POST",
            url: "/api/aggregation/get-ba-data",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
              url: account.url
            })
          })
            .done(function(response) {
              if (!response.months) {
                return;
              }
              var gross = 0;
              response.months.forEach(function(month) {
                for (var key in month) {
                  month[key.toLowerCase()] = month[key];
                }
                console.log(month);
                console.log(month.mg);
                gross += month.mg;
              });
              res({ gross: gross, months: response.months });
            })
            .fail(function(err) {
              console.log(err.responseText);
              alert(err.responseText);
            });
        } else {
          console.log(account.accountid);

          $.ajax({
            type: "POST",
            url: "/api/aggregation/get-account-summary",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
              timestamp: account.timestamp,
              accountid: account.accountid
            })
          })
            .done(function(response) {
              console.log(response);
              if (!response.months) {
                return;
              }
              var gross = 0;
              response.months.forEach(function(month) {
                console.log(month.mg);
                gross += month.mg;
              });
              res({ gross: gross, months: response.months });
            })
            .fail(function(err) {
              console.log(err.responseText);
              alert(err.responseText);
            });
        }
      });
    }
  },
  mounted: function() {
    var self = this;
    let m = moment();
    for (let i = 0; i < 6; i -= -1) {
      m.subtract(1, "months");
      self.inputs.months[i].iso = m.format("YYYY-MM");
    }
    // this.revSources = []
    self.accounts.forEach(function(account) {
      account.selected = false;
      self.revSources.push(JSON.parse(JSON.stringify(account)));
    });
    $.ajax({
      type: "POST",
      url: "/api/aggregation/get-fico-sources",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({
        appnum: this.appnum
      })
    })
      .done(function(response) {
        console.log(response);
        if (response.sources) {
          response.sources.forEach(source => {
            if (self.fico_index == -1) {
              self.populateFicoData(source, 0);
            }
            self.ficoSources.push(source);
          });
        }
      })
      .fail(function(err) {
        console.log(err.responseText);
        alert(err.responseText);
      });

    $.ajax({
      type: "POST",
      url: "/api/aggregation/get-ba-source",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({
        appnum: this.appnum
      })
    })
      .done(function(response) {
        console.log(response);
        if (response.source) {
          response.source.selected = true;
          self.revSources.push(JSON.parse(JSON.stringify(response.source)));
        }
      })
      .fail(function(err) {
        console.log(err.responseText);
        // alert(err.responseText);
      });

    $.ajax({
      type: "POST",
      url: "/api/aggregation/get-calc-fields",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({
        appnum: this.appnum
      })
    })
      .done(function(response) {
        console.log(response);
        self.crmFields = [];
        response.fields.forEach(field => {
          self.crmFields.push(field);
        });
      })
      .fail(function(err) {
        console.log(err.responseText);
        // alert(err.responseText);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bank-source {
  transition: all 0.3s;
  cursor: pointer;
  padding: 10px;
}
.bank-source:hover {
  background: #3c5cac;
}
.fico-source {
  transition: all 0.3s;
  cursor: pointer;
  padding: 10px;
}
.fico-source:hover {
  background: #5c8bd7;
}
.source-selected {
  background: green;
}
.source-selected:hover {
  background: #409740;
}
.card-footer {
  padding: 0.5rem 1.5rem;
  display: block;
}
.hidden {
  opacity: 0;
}
.shown {
  opacity: 1;
}
.select {
  width: 100%;
}
select {
  width: 100%;
}
.card-header-title {
  cursor: pointer;
}
.field:not(:last-child) {
  margin-bottom: 0px;
}
.columns.is-gapless:not(:last-child) {
  margin-bottom: 2px;
}
.columns.is-gapless:last-child {
  margin-bottom: 0;
}

.table-enter-active,
.table-leave-active {
  transition: all 0.2s;
}
.table-enter, .table-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  /* transform: translateY(30px); */
}
.ok-field {
  background: #e5ffe5;
}
.ineligible-month {
  background: #e7e7e7;
}
 </style>